import { useState } from "react";
import { toast } from "sonner";

const Payslips = () => {
  const [month, setMonth] = useState("August");
  const [year, setYear] = useState("2025");
  const [pdfUrl, setPdfUrl] = useState<string | null>(null);

  const viewPayslip = async () => {
  try {
    const res = await fetch(`/api/payslips?month=${month}&year=${year}`);

    if (!res.ok) {
      const errorData = await res.json();
      throw new Error(errorData.detail || "PDF not found");
    }

    const blob = await res.blob();
    const url = window.URL.createObjectURL(blob);
    setPdfUrl(url);
  } catch (err) {
    const message = err instanceof Error ? err.message : "An unexpected error occurred";
    toast.error(message);
    console.error("Error loading payslip:", err);
  }
};

  const downloadPdf = () => {
    if (!pdfUrl) return;
    const a = document.createElement("a");
    a.href = pdfUrl;
    a.download = `Payslip-${month}-${year}.pdf`;
    a.click();
  };

  return (
    <div className="max-w-xl mx-auto p-4">
      <h2 className="text-xl font-bold mb-4">Download Payslip</h2>
      <div className="flex space-x-2 mb-4">
        <select
          className="border p-2"
          value={month}
          onChange={(e) => setMonth(e.target.value)}
        >
          {[
            "January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
          ].map((m) => (
            <option key={m} value={m}>{m}</option>
          ))}
        </select>

        <select
          className="border p-2"
          value={year}
          onChange={(e) => setYear(e.target.value)}
        >
          {["2023", "2024", "2025", "2026"].map((y) => (
            <option key={y} value={y}>{y}</option>
          ))}
        </select>

        <button
          onClick={viewPayslip}
          className="bg-blue-600 text-white px-4 py-2 rounded"
        >
          View Payslip
        </button>
      </div>

      {pdfUrl && (
        <div>
          <iframe
            src={pdfUrl}
            title="Payslip PDF"
            className="w-full h-[90vh] border rounded-md shadow"
          />
          <div className="mt-4">
            <button
              onClick={downloadPdf}
              className="bg-green-600 text-white px-4 py-2 rounded"
            >
              Download PDF
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Payslips;
